import type { HTMLAttributes, ReactNode } from "react";
import { cn } from "../common/utils";

interface AdminCardProps extends HTMLAttributes<HTMLDivElement> {
  children: ReactNode;
  padded?: boolean;
}

interface AdminCardHeaderProps extends HTMLAttributes<HTMLDivElement> {
  title: string;
  icon?: string;
  action?: ReactNode;
}

export const AdminCard = ({ children, padded = false, className, ...props }: AdminCardProps) => {
  return (
    <div
      className={cn("bg-white rounded-lg border border-slate-200 shadow-sm", padded && "p-4", className)}
      {...props}
    >
      {children}
    </div>
  );
};

export const AdminCardHeader = ({ title, icon, action, className, ...props }: AdminCardHeaderProps) => {
  return (
    <div
      className={cn("flex flex-col items-stretch gap-3 border-b border-slate-100 px-4 py-3 sm:flex-row sm:items-center sm:justify-between", className)}
      {...props}
    >
      <div className="flex items-center gap-2 min-w-0">
        {icon && <i className={`${icon} text-slate-500 text-sm`} />}
        <h3 className="text-sm font-semibold text-slate-700 truncate">{title}</h3>
      </div>
      {action}
    </div>
  );
};
